// src/data/PublicationFiles/Publications_index.ts
import type { Publication } from '@data/types';
import { slugify } from '@utils/slugify';

const modules = import.meta.glob<{ default: Publication }>('./posts/*.ts', {
  eager: true,
});

export const publications: Publication[] = Object.values(modules).map(
  ({ default: pub }) => {
    if (!pub.link) {
      pub.slug = pub.slug || slugify(pub.title);
    }
    return pub;
  }
);

export type { Publication };
